import { cx } from '../cx'
import styles from './Loading.module.css'

export function Spinner({ tone = 'accent' }: { tone?: 'accent' | 'current' }) {
  return <span className={styles.spinner} data-tone={tone} aria-hidden="true" />
}

type SkeletonProps = {
  variant?: 'text' | 'circle' | 'rect'
  width?: `${number}%`
  lines?: number
  ground?: 'page' | 'surface'
  className?: string
}

type BlockProps = SkeletonProps & {
  variant: NonNullable<SkeletonProps['variant']>
  ground: NonNullable<SkeletonProps['ground']>
  hidden?: boolean
}

function Block({ variant, width, ground, className, hidden }: BlockProps) {
  return (
    <span
      className={cx(styles.block, className)}
      data-variant={variant}
      data-ground={ground}
      style={{ '--local-width': width }}
      aria-hidden={hidden ? 'true' : undefined}
    />
  )
}

export function Skeleton({
  variant = 'text',
  width,
  lines = 1,
  ground = 'page',
  className,
}: SkeletonProps) {
  if (variant === 'text' && lines > 1) {
    return (
      <span className={cx(styles.lines, className)} aria-hidden="true">
        {Array.from({ length: lines }, (_, i) => (
          <Block
            // biome-ignore lint/suspicious/noArrayIndexKey: identical static blocks
            key={i}
            variant={variant}
            width={width}
            ground={ground}
          />
        ))}
      </span>
    )
  }
  return (
    <Block
      variant={variant}
      width={width}
      ground={ground}
      className={className}
      hidden
    />
  )
}
